<template v-on:change="$emit('change', $event.target.checked)">
  <div>
    <div id="map" class="map-canvas-2"></div>
  </div>
</template>

<script>
import { API_KEY } from "./Maps/API_KEY";
import GoogleMapsLoader from "google-maps";
import { mapGetters, mapActions, mapMutations } from "vuex";
GoogleMapsLoader.KEY = API_KEY;
GoogleMapsLoader.LIBRARIES.push("places");
GoogleMapsLoader.WINDOW_CALLBACK_NAME = "initAutocomplete";
GoogleMapsLoader.VERSION = 3.43;
var map, google;

export default {
  name: "google-map",
  //valor inicial del toogle-button
  data() {
    return {
      coordinates: [],
      polygon: null,
      fullCordinates: []
    };
  },
  props: ["coord", "reset"],
  watch: {
    reset: function(newValue, oldValue) {
      if (newValue) {
        this.coordinates = [];
        if (this.polygon) {
          this.polygon.setMap(null);
        }
      }
      this.restartCoordinates();
    },
    coordinates: function() {
      this.getFullCordinates();
    },
    fullCordinates: function() {
      this.sendCoordinates();
    },
    coord: function(newValue, oldValue) {
      if (newValue.length > 0) {
        this.coordinates = newValue;
        GoogleMapsLoader.load(google => {
          this.initMap(google);
        });
      }
    }
  },
  methods: {
    // inicializar mapa de google

    initMap(google) {
      //Coordenada iniciales para el mapa
      this.google = google;
      let center = this.getCenter(this.coord, google);

      let lat = this.coord.length > 0 ? center.lat() : 40.748817;
      let lng = this.coord.length > 0 ? center.lng() : -73.985428;
      this.coordinates = this.coord.length > 0 ? this.coord : [];
      let color = "#5e72e4";
      let zoom = this.coord.length > 0 ? 11 : 2;
      map = document.getElementById("map");

      //instanciación de objeto de latitud y longitud para coordenadas iniciales
      let myLatlng = new google.maps.LatLng(lat, lng);
      //Configuracion inicial para el mapa
      let mapOptions = {
        zoom: zoom,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      map = new google.maps.Map(map, mapOptions);
      //Evento que registra los puntos en el mapa
      if (this.coordinates.length > 0) {
        this.polygon = new google.maps.Polygon({
          paths: this.coordinates,
          editable: true,
          strokeColor: "#FF0000",
          strokeOpacity: 0.6,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35
        });
        //Colocar poligono en el mapa
        this.polygon.setMap(map);
        //Agregar evento para mostrar coordenadas

        this.polygon.addListener("set_at", this.getFullCordinates());

        this.polygon.getPaths().forEach((path, index) => {
          google.maps.event.addListener(path, "insert_at", () => {
            this.getFullCordinates();
          });

          google.maps.event.addListener(path, "remove_at", () => {
            this.getFullCordinates();
          });

          google.maps.event.addListener(path, "set_at", () => {
            this.getFullCordinates();
          });
        });
      }

      google.maps.event.addListener(map, "click", event => {
        //Eliminar Poligono anterior
        if (this.polygon) {
          this.polygon.setMap(null);
        }
        //Agregar nueva Coordenada
        this.coordinates.push({
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        });

        //instanciar objeto del poligono
        this.polygon = new google.maps.Polygon({
          paths: this.coordinates,
          editable: true,
          strokeColor: "#FF0000",
          strokeOpacity: 0.6,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35
        });
        //Colocar poligono en el mapa
        this.polygon.setMap(map);
        //Agregar evento para mostrar coordenadas
        this.polygon.addListener("set_at", this.getFullCordinates());
        this.polygon.getPaths().forEach((path, index) => {
          google.maps.event.addListener(path, "insert_at", () => {
            this.getFullCordinates();
          });

          google.maps.event.addListener(path, "remove_at", () => {
            this.getFullCordinates();
          });

          google.maps.event.addListener(path, "set_at", () => {
            this.getFullCordinates();
          });
        });
      });

      var input = document.getElementById("autocomplete");
      var autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["geocode"]
      });

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      autocomplete.setFields(["address_component", "geometry"]);
      autocomplete.addListener("place_changed", () => {
        if (this.polygon) {
          this.coordinates = [];
          this.polygon.setMap(null);
        }
        var place = autocomplete.getPlace();
        map.setCenter(place.geometry.location);
        map.setZoom(15); // Why 17? Because it looks good.
        var marker = new google.maps.Marker({
          map: map,
          position: place.geometry.location
        });
      });
    },
    createMarker(place) {
      var marker = new google.maps.Marker({
        map: map,
        position: place.geometry.location
      });
    },
    //delete polygon from map
    deleteCoordinates() {
      this.coordinates = [];

      if (this.polygon) {
        this.polygon.setMap(null);
      }
    },
    //emit coordinates
    sendCoordinates() {
      this.$emit("getFullCoordinates", this.fullCordinates);
    },
    restartCoordinates() {
      this.$emit("restartCoordinates", false);
    },
    getCenter(coord, google) {
      var bounds = new google.maps.LatLngBounds();
      let coordinates = coord.map(
        element => new google.maps.LatLng(element.lat, element.lng)
      );
      coordinates.forEach(element => {
        bounds.extend(element);
      });
      return bounds.getCenter();
    },
    getFullCordinates() {
      if (this.polygon) {
        var vertices = this.polygon.getPath();
        this.fullCordinates = [];
        // Iterar sobre los vertices para obtener coordenadas.
        for (var i = 0; i < vertices.getLength(); i++) {
          var xy = vertices.getAt(i);
          //Agregar al array de coordenadas
          this.fullCordinates.push({
            lat: xy.lat(),
            lng: xy.lng()
          });
        }
      } else {
        this.fullCordinates = [];
      }
    }
  },
  mounted() {
    GoogleMapsLoader.load(google => {
      this.initMap(google);
    });
  },
  components: {}
};
</script>
